module.exports = __webpack_public_path__ + "img/00bcfa0.jpg";